export const truckloadShipmentStatusColors = {
  Canceled: 'red',
  'Carrier assigned': 'teal',
  Completed: 'blue',
  Delivered: 'blue',
  Expired: 'gray',
  'In transit': 'purple',
  'Needs carrier': 'gray',
  Pending: 'gray'
}

export const oceanShipmentStatusColors = {
  'Arrived at destination port': 'blue',
  'Arrived at destination rail ramp': 'blue',
  Cancelled: 'red',
  Created: 'gray',
  Delivered: 'blue',
  'On rail': 'blue',
  'On ship': 'blue'
}
